import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/brand/gyre-logo-full-pill.png'


const _hoisted_1 = {
  key: 0,
  class: "navbar navbar-default navbar-fixed-top"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "burger-menu" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "navbar-header" }
const _hoisted_6 = { class: "nav navbar-nav" }
const _hoisted_7 = { class: "team-button-container" }
const _hoisted_8 = {
  key: 0,
  class: "team-button-container"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "caret" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", { class: "jyre-logo-container" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/home" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Gyre",
      class: "jyre-top-nav-logo"
    })
  ])
], -1)
const _hoisted_11 = { class: "nav navbar-nav navbar-right" }
const _hoisted_12 = { class: "dropdown notifications" }

import { computed, ref, onMounted } from "vue";
import Debug from "debug";
import UserNotificationsDropdown from "../notifications/user-notifications-dropdown.vue";
import { UserSelfDocumentApiModel } from "../../api-models";
import SearchBar from "../search-bar.vue";
import { csContext } from "../../services/cs-context";
import TeamPickerDialog from "../team-picker-dialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'top-nav',
  props: {
    model: {},
    sideNavIsOpen: { type: Boolean }
  },
  setup(__props: any) {

const debug = Debug("cs.Navbar");

const props = __props;

const teamPickerDialog = ref<InstanceType<typeof TeamPickerDialog>>();

onMounted(() => {
  debug("Mounted", props.model);
});

const currentTeam = computed(() => csContext.currentTeam);

const canCreateTeams = computed(() => props.model.platformPermissions.includes("CreateTeams"));

function pickDifferentTeam(): void {
  teamPickerDialog.value?.open();
}

const canSearch = computed(() => {
  return !props.model.platformPermissions.includes("AdministerPlatform");
});

return (_ctx: any,_cache: any) => {
  return (_ctx.model)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TeamPickerDialog, {
          ref_key: "teamPickerDialog",
          ref: teamPickerDialog,
          teams: _ctx.model.teams,
          "can-create-teams": canCreateTeams.value
        }, null, 8, ["teams", "can-create-teams"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-side-nav'))),
            class: "container side-nav-toggle-btn",
            "aria-label": "burger menu",
            type: "button"
          }, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("a", {
                  class: "btn btn-default",
                  style: _normalizeStyle({ borderRadius: !!_ctx.model.teams.length ? '20px 0 0 20px' : '20px' }),
                  href: "/team/create"
                }, "Setup a new team", 4)
              ]),
              (currentTeam.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createElementVNode("a", {
                      href: "javascript: void(0);",
                      onClick: pickDifferentTeam,
                      class: "btn btn-default",
                      "data-test": "change-team-button",
                      style: {"border-radius":"0 20px 20px 0","left":"-1px"}
                    }, [
                      _createTextVNode(_toDisplayString(currentTeam.value.name) + " ", 1),
                      _hoisted_9
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_10
            ])
          ]),
          _createElementVNode("ul", _hoisted_11, [
            _createElementVNode("li", _hoisted_12, [
              _createVNode(UserNotificationsDropdown)
            ]),
            (canSearch.value)
              ? (_openBlock(), _createBlock(SearchBar, {
                  key: 0,
                  "side-nav-is-open": _ctx.sideNavIsOpen
                }, null, 8, ["side-nav-is-open"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})